import { useDispatch } from 'react-redux';
import { ChevronRightIcon } from '@grupoboticario/flora-react-icons';
import Styles from './PaymentsGroup.styles';
import { setPaymentOption, setStep } from 'core/use-cases/checkout/actions/actions';
import type { PaymentDetail, PaymentMethods, Payments } from 'core/domains/checkout';
import type { PaymentInfo } from 'core/domains/cart';

type TPaymentGroupMethodSelect = {
  selectedGroup: keyof PaymentMethods;
  paymentMethods: PaymentMethods;
};

export const PaymentGroupMethodSelect = ({
  selectedGroup,
  paymentMethods,
}: TPaymentGroupMethodSelect) => {
  const dispatch = useDispatch();
  const selectedPaymentGroup = paymentMethods[selectedGroup] as Payments;
  const selectMethod = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.currentTarget;
    const code = target.getAttribute('data-payment-code') || '';
    const mode = target.getAttribute('data-payment-mode') || '';
    dispatch(setPaymentOption({ code, mode, planType: selectedGroup }));
    dispatch(setStep('summary'));
  };
  return (
    <>
      {selectedPaymentGroup?.paymentInfo.map((payment: PaymentDetail) => (
        <Styles.PaymentOption
          key={payment.name}
          data-stargate
          data-payment-code={payment.paymentCode}
          data-payment-mode={payment.paymentMode}
          onClick={selectMethod}
        >
          <Styles.PaymentOptionsLabels>
            <Styles.PaymentOptionTitle fontSize="bodySmallStandard">
              {payment?.name === 'centralPayment'
                ? (selectedPaymentGroup as Partial<PaymentInfo>).name
                : payment.name}
            </Styles.PaymentOptionTitle>
          </Styles.PaymentOptionsLabels>
          <ChevronRightIcon size={16} />
        </Styles.PaymentOption>
      ))}
    </>
  );
};
